import {Box} from 'platform/foundation';

import {SaleVehiclePhotoType} from '@dms/api/settings';
import {Sortable} from '@dms/features/dnd';

import {TestIdProps} from 'shared/web';

import {PhotoGuideSlotPlaceholder} from './PhotoGuideSlotPlaceholder';

interface PhotoGuideEmptySlotTileProps extends TestIdProps {
  dndId: string;
  photoType: SaleVehiclePhotoType;
  isRequired: boolean;
  canEdit: boolean;
  isDropTarget: boolean;
}

/** An empty slot in the Guide Layout: sortable like a photo and a drop target for a Backlog photo. */
export function PhotoGuideEmptySlotTile(props: PhotoGuideEmptySlotTileProps) {
  return (
    <Sortable id={props.dndId} disabledDrag={!props.canEdit} disabledDrop={!props.canEdit}>
      {({isDragging}) => (
        <Box opacity={isDragging ? 0.5 : 1}>
          <PhotoGuideSlotPlaceholder
            photoType={props.photoType}
            isRequired={props.isRequired}
            isDropTarget={props.isDropTarget}
            data-testid={props['data-testid']}
          />
        </Box>
      )}
    </Sortable>
  );
}
